// extracted by mini-css-extract-plugin
export var blueBlock = "footer-module--blueBlock--93zNJ";
export var blueSpan = "footer-module--blueSpan--VSy+U";
export var br34k = "footer-module--br34k--aG9lo";
export var greenBlock = "footer-module--greenBlock--W8U7X";
export var greenSpan = "footer-module--greenSpan--iPwke";
export var pplink = "footer-module--pplink--bJnuR";